import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import Icon from 'yoda-core-components/lib/components/Icon';
import List from 'yoda-core-components/lib/components/List/List';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import SocialShare from 'yoda-core-components/lib/components/SocialShare/SocialShare';
import Accordion from 'yoda-core-components/lib/components/Accordion/accordion';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { isAgentLogged } from 'yoda-core-components/lib/helpers/Utils/Utils';
import SiteComponent from '../../../SiteComponent/SiteComponent';
import LinkConnected from '../../../Link/Link';
import YodaGetTheAppConnected from '../GetTheApp';
import Subscription from '../Subscription';

import footerConfig from '../../config';
import { footerLinksIconMapping } from '../../YodaFooterIconMapping';

import styles from './index.css';

const cx = classNames.bind(styles);

export class FooterLinks extends SiteComponent {
    static defaultProps = {
        deviceType: {},
        expandedFooter: false,
        enableFooterAppBanner: true,
        externalStaticBasePath: '',
        footerLinkMenus: [],
        enableIrisFooterApi: false,
        plccViewAnalyticsActions: () => {},
        plccApplyAnalyticsActions: () => {},
        plccAnalyticsTagName: '',
    };

    static propTypes = {
        deviceType: PropTypes.object,
        expandedFooter: PropTypes.bool,
        footerMenus: PropTypes.object.isRequired,
        enableFooterAppBanner: PropTypes.bool,
        externalStaticBasePath: PropTypes.string.isRequired,
        footerLinkMenus: PropTypes.array,
        enableIrisFooterApi: PropTypes.bool,
        plccApplyAnalyticsActions: PropTypes.objectOf(PropTypes.func),
        plccViewAnalyticsActions: PropTypes.objectOf(PropTypes.func),
        plccAnalyticsTagName: PropTypes.string,
    };

    constructor() {
        super();
        this.onFooterLinkClickedBound = this.onFooterLinkClicked.bind(this);
        this.anchorRenderer = this.anchorRenderer.bind(this);
        this.plccTriggerViewAnalytics = false;
    }

    /* istanbul ignore next */
    onFooterLinkClicked = (event, linkUrl, openInNewTab = true) => {
        const { enableIrisFooterApi } = this.props;
        event.preventDefault();
        return {
            url: linkUrl,
            openInNewTab: enableIrisFooterApi ? openInNewTab : true,
        };
    };

    anchorRenderer(dataItem, deviceType, AdChoiceImg, externalStaticBasePath) {
        /* istanbul ignore next */
        const { enableIrisFooterApi } = this.props;
        const {
            linkPath = '',
            linkPathMobile = '',
            text = '',
            iconName = '',
            id = '',
            openInNewTab,
            analyticsTag = '',
        } = dataItem;
        const str = linkPath;
        let linkData;
        /* istanbul ignore next */
        const linkUrl = deviceType.isDesktop || enableIrisFooterApi ? linkPath : linkPathMobile;
        const isLogoutNeeded = !!dataItem.isLogoutNeeded;
        const anchorStyleCss = dt([
            'sm:text-black',
            'smOnly:text-base',
            'smOnly:leading-6',
            'md:text-sm',
            'md:leading-5',
            'tracking-normal',
            'lg:float-left',
            'lg:w-full',
            'lg:text-left',
        ]);
        const adChoiceImgStyle = dt([
            '-mt-1.5',
            'h-4',
            'lg:w-[17.8px]',
            'md:w-[17.8px]',
            'sm:w-[17.8px]',
            'object-contain',
            'align-middle',
            'inline-block',
            'my-0',
            'ml-1',
            'mr-0',
        ]);
        if (str.startsWith('/')) {
            linkData = (
                <LinkConnected
                    href={linkUrl}
                    className={`${cx('anchorStyle', 'linkStyle1')} ${anchorStyleCss}`}
                    aria-label={text}
                    data-automation-id="footer-link"
                    key={id}
                    triggerAnalytics
                    onClick={(event) => {
                        event.preventDefault();
                        return {
                            url: linkUrl,
                            openInNewTab: enableIrisFooterApi ? openInNewTab : false,
                        };
                    }}
                    linkName={`footer:${text.toLowerCase()}`}
                >
                    {dataItem.text}
                </LinkConnected>
            );
        } else if (str.startsWith('#')) {
            linkData = (
                <LinkConnected
                    className={`${cx(
                        'anchorStyle',
                        'linkStyle1',
                        'ot-sdk-show-settings '
                    )} ${anchorStyleCss}`}
                    aria-label={text}
                    data-automation-id="footer-link"
                    rel="noopener noreferrer"
                    key={dataItem.id}
                    triggerAnalytics
                    linkName={`footer:${text.toLowerCase()}`}
                >
                    {text}
                </LinkConnected>
            );
        } else {
            const {
                plccViewAnalyticsActions,
                plccAnalyticsTagName,
                plccApplyAnalyticsActions,
            } = this.props;
            if (
                analyticsTag.toUpperCase().includes(plccAnalyticsTagName) &&
                !this.plccTriggerViewAnalytics
            ) {
                const payloadParams = {
                    plccBanner: 'footer_apply',
                };

                plccViewAnalyticsActions(payloadParams);
                this.plccTriggerViewAnalytics = true;
            }
            linkData = (
                <LinkConnected
                    href={linkUrl}
                    className={`${cx('anchorStyle', 'linkStyle3')} ${anchorStyleCss}`}
                    aria-label={text}
                    data-automation-id="footer-link"
                    onClick={
                        /* istanbul ignore next */
                        (event) => {
                            /* if (text === 'Apply for JCP Credit Card' && dataItem.key === 4) {
                                const { act } = this.props;
                                triggerPLCCAnalytics(analyticsActions.plccApplyAnalytics, {
                                    plccBanner: 'footer_apply',
                                    href: linkUrl,
                                });
                            } */
                            if (analyticsTag.toUpperCase().includes(plccAnalyticsTagName)) {
                                const payloadParams = {
                                    plccBanner: 'footer_apply',
                                };
                                plccApplyAnalyticsActions(payloadParams);
                            }
                            if (isLogoutNeeded) {
                                event.preventDefault();
                                TokenProvider.logout();
                                return {
                                    url: linkUrl,
                                    openInNewTab: false,
                                };
                            }
                            return this.onFooterLinkClickedBound(event, linkUrl, openInNewTab);
                        }
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    key={dataItem.id}
                    data-plcc-id={
                        text === 'Apply for JCP Credit Card' ? 'at-link-plccBanner-id' : ''
                    }
                    triggerAnalytics
                    linkName={`footer:${text.toLowerCase()}`}
                >
                    {text}
                </LinkConnected>
            );
        }
        if (text && text === footerConfig.AdChoices) {
            linkData = (
                <a
                    href={linkUrl}
                    className={`${cx('anchorStyle', 'linkStyle4')} ${anchorStyleCss}`}
                    aria-label={text}
                    data-automation-id="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    key={id}
                >
                    {text}
                    <img
                        className={`${cx('adChoiceImg')} ${adChoiceImgStyle}`}
                        src={`${externalStaticBasePath}/yoda-assets/${AdChoiceImg}`}
                        alt=""
                    />
                </a>
            );
        }
        const socialIconStyle = dt(['float-none', 'text-center', 'block']);
        const socialIconSvgStyle = dt(['block', 'm-0', 'text-black']);
        if (iconName) {
            linkData = (
                <LinkConnected
                    href={linkUrl}
                    className={`${cx(
                        'anchorStyle',
                        'socialIcon'
                    )} ${anchorStyleCss} ${socialIconStyle}`}
                    aria-label={text}
                    data-automation-id="footer-link"
                    onClick={
                        /* istanbul ignore next */
                        (event) => this.onFooterLinkClickedBound(event, linkUrl, true)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    triggerAnalytics
                    linkName={`footer:${text.toLowerCase()}`}
                >
                    <Icon
                        automationId="footer-get-icon"
                        className={`${styles.socialIconSvg} ${socialIconSvgStyle}`}
                        height="35"
                        width="35"
                    >
                        {footerLinksIconMapping[iconName]}
                    </Icon>
                </LinkConnected>
            );
        }

        return linkData;
    }

    render() {
        /* istanbul ignore next */
        const {
            deviceType,
            expandedFooter,
            footerMenus = {},
            enableFooterAppBanner,
            externalStaticBasePath,
        } = this.props;

        const { isMobile = false } = deviceType;
        const {
            flags: {
                hideFooterLinks = false,
                hideSocialShare = false,
                hideLegalNote = false,
                hideSubscription = false,
            } = {},
        } = footerMenus;
        const { AdChoiceImg, MediaNote } = footerConfig;
        const jcpLegal = (
            <List
                datasource={footerMenus?.TermsLegal?.slice(0, 3) || []}
                listDataId="rewards"
                childRenderer={(item) =>
                    this.anchorRenderer(item, deviceType, AdChoiceImg, externalStaticBasePath)
                }
                listBodyClass={styles.footerJCPTermsBlock}
                listStyleClass={styles.footerJCPTermsList}
                itemStyleClass={styles.footerJCPTermsListItem}
                direction="Vertical"
                spacing="None"
                automationId="footer-jcp-privacy"
            />
        );
        const jcpPrivacy = (
            <List
                datasource={footerMenus.Privacy}
                listDataId="rewards"
                childRenderer={(item) =>
                    this.anchorRenderer(item, deviceType, AdChoiceImg, externalStaticBasePath)
                }
                listBodyClass={styles.footerJCPTermsBlock}
                listStyleClass={styles.footerJCPTermsList}
                itemStyleClass={styles.footerJCPTermsListItem}
                direction="Vertical"
                spacing="None"
                automationId="footer-jcp-privacy-two"
                itemClassName="jcpPrivacy"
            />
        );

        const connectUsStyle = dt(['text-center', 'inline-block', 'align-middle']);
        const footerConnectUsBlockStyle = dt([
            'my-0',
            'mx-auto',
            'overflow-hidden',
            'text-center',
            'inline-block',
            'align-middle',
        ]);
        const footerConnectUsListStyle = dt(['text-center', 'block']);
        const footerConnectUsListItemStyle = dt([
            'text-center',
            'w-10',
            'inline-block',
            'align-middle',
            'first:ml-0',
        ]);
        const desktopsocialShare = (
            <div
                data-automation-id="connect-us-block"
                className={`${dt(['inline-block', 'my-0'])}
                    /* istanbul ignore next */
                    ${cx(
                        'connectUs',
                        connectUsStyle,
                        enableFooterAppBanner ? 'withAppBanner' : ''
                    )}`}
            >
                <List
                    datasource={footerMenus.ConnectWithUs}
                    listDataId="connectwithUs"
                    childRenderer={(item) =>
                        this.anchorRenderer(item, deviceType, AdChoiceImg, externalStaticBasePath)
                    }
                    listBodyClass={`${styles.footerConnectUsBlock} ${footerConnectUsBlockStyle}`}
                    listStyleClass={`${styles.footerConnectUsList} ${footerConnectUsListStyle}`}
                    itemStyleClass={`${styles.footerConnectUsListItem} ${footerConnectUsListItemStyle}`}
                    spacing="None"
                    automationId="footer-jcp-connect-with-us"
                />
            </div>
        );

        /* istanbul ignore next */
        const socialShare = () => {
            const { ConnectWithUs } = footerMenus;
            if (!ConnectWithUs) {
                return null;
            }

            return (
                <div
                    data-automation-id="footer-social-share"
                    className={`${styles.socialWrap} ${dt(['text-center', 'inline-block'])}`}
                    id="footer-social-share"
                >
                    <SocialShare
                        automationId="footer-social-share"
                        iconClass="class1 class2"
                        socialShareIcons={ConnectWithUs}
                        AnchorComponent={LinkConnected}
                    />
                </div>
            );
        };

        /* istanbul ignore next */
        const accordianSection = () => {
            const { footerLinkMenus, enableIrisFooterApi } = this.props;
            const footerLinks =
                footerLinkMenus.length > 0 && enableIrisFooterApi
                    ? footerLinkMenus
                    : footerMenus.FooterLinks;
            let footerLinkArr = [];
            if (footerLinks) {
                footerLinkArr = footerLinks.map((value, index) => {
                    const dataToRender = value.data;
                    const footerJCPPrivacyListItemStyle = dt(['text-left']);
                    const footerLinkList = (
                        <List
                            automationId={`footer-${value.text}`}
                            childRenderer={(item) =>
                                this.anchorRenderer(item, deviceType, AdChoiceImg)
                            }
                            listStyleClass={dt([
                                'smOnly:!flex',
                                'flex-col',
                                'gap-y-2',
                                'pt-0',
                                'pr-0',
                                'pl-2',
                                'pb-2',
                            ])}
                            datasource={dataToRender}
                            direction="Vertical"
                            itemStyleClass={cx(
                                'footerJCPPrivacyListItem',
                                footerJCPPrivacyListItemStyle,
                                {
                                    removeFloat: deviceType.isTablet,
                                }
                            )}
                            key={`footer-list-${value.key}`}
                            listDataId="rewards"
                            spacing="None"
                        />
                    );

                    return {
                        header: value.text,
                        panel: footerLinkList,
                        key: `footerlink-${index}`,
                    };
                });
            }
            return footerLinkArr;
        };

        /* istanbul ignore next */
        const articalSection = () => {
            const { footerLinkMenus, enableIrisFooterApi } = this.props;
            const footerLinks =
                footerLinkMenus.length > 0 && enableIrisFooterApi
                    ? footerLinkMenus
                    : footerMenus.FooterLinks;
            let footerLinkArr = [];
            if (footerLinks) {
                footerLinkArr = footerLinks.map((value) => {
                    let footerLinkList;
                    if (value.data && _get(value, 'data', []).length > 0) {
                        footerLinkList = (
                            <List
                                datasource={value.data}
                                key={`footer-list-${value.key}`}
                                listDataId="rewards"
                                childRenderer={(item) =>
                                    this.anchorRenderer(
                                        item,
                                        deviceType,
                                        AdChoiceImg,
                                        externalStaticBasePath
                                    )
                                }
                                itemStyleClass={styles.footerJCPPrivacyListItem}
                                direction="Vertical"
                                spacing="None"
                                automationId={`footer-${value.text}`}
                            />
                        );
                    }
                    const footerLinksStyle = dt([
                        'lg:table-cell',
                        'text-left',
                        'md:block',
                        'md:w-1/4',
                    ]);
                    const footerLinkTitleStyle = dt([
                        'text-small',
                        'font-bold',
                        'leading-4',
                        'text-black',
                        'mb-2',
                    ]);
                    return (
                        <div
                            key={value.key || value.text}
                            className={`${styles.footerLinks} ${footerLinksStyle}`}
                        >
                            <h5
                                className={cx('footerLinkTitle', footerLinkTitleStyle)}
                                data-automation-id={`article-sec-${value.text}`}
                            >
                                {' '}
                                {value.text}{' '}
                            </h5>
                            {footerLinkList}
                        </div>
                    );
                });
            }
            return footerLinkArr;
        };

        /* istanbul ignore next */
        const footerAccordionStyle = dt(['p-0']);
        const deviceFooterlinks = () =>
            expandedFooter ? (
                <Accordion
                    className={footerAccordionStyle}
                    automationId="footer-accordian-mobile-footer"
                    children={accordianSection()}
                    toggleOnlyOne
                    parentSection="footer"
                />
            ) : null;
        const footerLinksBlockStyle = dt([
            'inline-block',
            'align-middle',
            'sm:w-full',
            'p-0',
            'md:pb-6',
            'sm:border-b',
            'md:border-none',
            'lg:border-solid',
            'lg:border-gray-25',
            'lg:w-[66.8%]',
            'lg:border-r',
            'lg:border-b-0',
            'lg:border-t-0',
            'lg:border-l-0',
        ]);
        const footerMainLinksStyle = dt(['lg:table', 'md:flex', 'w-full']);
        const desktopFooterLinks = () =>
            /* istanbul ignore next */
            expandedFooter ? (
                <article
                    data-automation-id="footer-links-block"
                    className={`${styles.footerLinksBlock} ${footerLinksBlockStyle}`}
                >
                    <section className={`${styles.footerMainLinks} ${footerMainLinksStyle}`}>
                        {articalSection()}
                    </section>
                </article>
            ) : (
                ''
            );
        /* istanbul ignore next */
        const enableDSARRequestClass = 'withDataRightReq';
        const footerJCPCopyRightsStyle = dt([
            'text-xs',
            'leading-5',
            'text-gray-60',
            'font-open-sans-regular',
            'flex',
            'items-center',
        ]);
        const copyRightWrapStyle = dt([
            'lg:w-full',
            'md:w-[725px]',
            'sm:w-[80%]',
            'sm:mx-auto',
            'overflow-hidden',
        ]);
        const copyRightTextStyles = dt([
            'md:text-black',
            'md:text-xsmall',
            'smOnly:pl-0',
            'smMd:text-center',
        ]);
        const privacyLegalLinksStyles = dt(['text-center', 'sm:w-full', 'sm:pb-8', 'smOnly:block']);
        /* istanbul ignore next */
        const deviceLegalNote = () => (
            <div className={cx('copyRightWrap', enableDSARRequestClass, copyRightWrapStyle)}>
                <div
                    className={
                        deviceType.isTablet
                            ? `${cx(
                                  'reduceWidth',
                                  styles.privacyLegalLinks
                              )} ${privacyLegalLinksStyles}`
                            : `${styles.privacyLegalLinks} ${privacyLegalLinksStyles}`
                    }
                    data-automation-id="footer-privacy"
                >
                    <div className={cx('footerJCPTermsWrap', 'footerPrivacyWrap')}>
                        {jcpPrivacy}
                    </div>
                    <div className={cx('footerJCPLegal-container')}>
                        <div className={cx('footerJCPLegal', styles.footerJCPTermsWrap)}>
                            {jcpLegal}
                        </div>
                        <ul
                            className={`${dt([
                                'lg:inline-block',
                                'lg:mr-2.5',
                                'md:inline-block',
                                'md:mr-2.5',
                                'text-center',
                            ])} ${cx('jcpRightInfo')}`}
                        >
                            <li
                                data-automation-id="footer-copy"
                                className={footerJCPCopyRightsStyle}
                            >
                                &copy;{` ${new Date().getFullYear()} ${MediaNote}`}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
        const desktopLegalNote = () => (
            <div
                data-automation-id="copy-right-wrap"
                className={cx('copyRightWrap', enableDSARRequestClass, copyRightWrapStyle)}
            >
                <div
                    className={`${styles.privacyLegalLinks} ${privacyLegalLinksStyles}`}
                    data-automation-id="footer-privacy"
                >
                    <div
                        data-automation-id="footer-privacy-block"
                        className={cx('footerJCPTermsWrap', 'footerPrivacyWrap')}
                    >
                        {jcpPrivacy}
                    </div>
                    <div className={cx('footerJCPLegal-container')}>
                        <div
                            data-automation-id="footer-jcp-terms-block"
                            className={cx('footerJCPLegal', styles.footerJCPTermsWrap)}
                        >
                            {jcpLegal}
                        </div>
                        <div
                            data-automation-id="footer-copyright-text"
                            className={`${copyRightTextStyles} ${styles.copyRightText}`}
                        >
                            <div
                                data-automation-id="footer-copy"
                                className={cx('footerJCPMedia', footerJCPCopyRightsStyle)}
                            >
                                &copy;{` ${new Date().getFullYear()} ${MediaNote}`}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        /* istanbul ignore next */
        const desktopAppBanner = () => (
            <YodaGetTheAppConnected
                theme="inFooterLinks"
                deviceType={deviceType}
                enableFooterAppBanner
                footerAppBannerDetails={footerMenus.DownloadApp}
            />
        );

        const subscriptionBlock = () => (
            <Subscription
                expandedFooter={expandedFooter}
                deviceType={deviceType}
                offerMessageData={footerMenus}
            />
        );

        /* istanbul ignore next */
        const socialAppBlockStyle = dt([
            'lg:mt-8',
            'md:mt-8',
            'sm:mt-4',
            'mb-6',
            'mx-0',
            'text-center',
            'md:my-6',
        ]);
        const getAppBlockStyle = dt([
            'sm:w-full',
            'md:w-fit',
            'lg:w-auto',
            'sm:mt-6',
            'sm:ml-0',
            'inline-block',
            'align-middle',
            'md:mt-0',
            'md:ml-3',
        ]);
        const footerLinksSubscriptionBlockStyle = dt([
            'smOnly:pb-4',
            'md:py-8',
            'md:px-5',
            'bg-light-white',
            'lg:py-8',
            'lg:pr-0',
            'lg:pl-6',
            'clear-both',
        ]);

        const captchaAppBlockStyle = dt(['m-6', 'text-center']);

        const deviceFooterRenderer = () => (
            <div className={`${cx('footerMobileBlock')} ${dt(['mt-2'])}`}>
                <div
                    className={cx(
                        'footerLinksSubscriptionBlock',
                        footerLinksSubscriptionBlockStyle
                    )}
                >
                    <div className="containerWidth">
                        {!hideFooterLinks && deviceFooterlinks()}
                        {!hideSubscription && subscriptionBlock()}
                    </div>
                </div>
                <div className={cx('socialAppBlock', socialAppBlockStyle)}>
                    {!hideSocialShare && socialShare()}
                    <div className={cx('getAppBlock', getAppBlockStyle)}>
                        {enableFooterAppBanner && desktopAppBanner()}
                    </div>
                </div>
                {!hideLegalNote && deviceLegalNote()}
            </div>
        );

        const desktopFooterRenderer = () => (
            <>
                {!isAgentLogged() && (
                    <div
                        className={cx(
                            'footerLinksSubscriptionBlock',
                            'desktopFooter',
                            footerLinksSubscriptionBlockStyle
                        )}
                    >
                        <div className="containerWidth">
                            {!hideFooterLinks && desktopFooterLinks()}
                            {!hideSubscription && subscriptionBlock()}
                        </div>
                    </div>
                )}
                <div className={cx('socialAppBlock', socialAppBlockStyle)}>
                    {!hideSocialShare && desktopsocialShare}
                    <div className={cx('getAppBlock', getAppBlockStyle)}>
                        {
                            /* istanbul ignore next */
                            enableFooterAppBanner && desktopAppBanner()
                        }
                    </div>
                </div>
                {!hideLegalNote && desktopLegalNote()}
            </>
        );

        /* istanbul ignore next */
        const footerRenderer = isMobile ? deviceFooterRenderer : desktopFooterRenderer;

        return (
            <div className={`${cx('footerListBlock')} ${dt(['bg-white'])}`}>{footerRenderer()}</div>
        );
    }
}

export default FooterLinks;
